import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

function LogoList({ data }) {
  const { items } = data.logo_list_horizontal;
  const componentId = data.logo_list_horizontal._metadata.uid;

  return (
    <div
      id={componentId}
      className={`grid grid-cols-${items.length} mx-auto my-10 max-w-[800px] items-center gap-12`}
    >
      {items.map((item, index) => (
        <Item data={item} index={index} key={index} />
      ))}
    </div>
  );
}

export default LogoList;

function Item({ data, index }) {
  const imageConnection = data.image;
  const dataRef = data.reference[0];

  switch (data.link_type) {
    case 'Link':
      return (
        <a
          href={data.link.href}
          title={data.label}
          target="_blank"
          rel="external noopener noreferrer"
          key={index}
        >
          <Image
            src={imageConnection.url}
            alt={imageConnection.title}
            height="71"
            width="208"
            sizes="208px"
            className="w-52"
          />
        </a>
      );
    case 'Reference':
      return (
        <Link
          href={dataRef.url}
          key={index}
          prefetch={false}
          title={data.label}
          className="text-center"
        >
          <Image
            src={imageConnection.url}
            alt={imageConnection.title}
            height="71"
            width="208"
            sizes="208px"
            className="w-52"
          />
        </Link>
      );
    case 'No Link':
      return (
        <Image
          src={imageConnection.url}
          alt={imageConnection.title}
          height="71"
          width="208"
          sizes="208px"
          key={index}
          className="mx-auto w-52"
        />
      );
    default:
      return (
        <Image
          src={imageConnection.url}
          alt={imageConnection.title}
          height="71"
          width="208"
          sizes="208px"
          key={index}
          className="mx-auto w-52"
        />
      );
  }
}
